import { isEmpty } from "@core-ui/helpers/Utils";
import { AriaHidden } from "@core-ui/components/accessibility";
import React, { memo, ReactElement } from "react";
import classNames from "classnames";
import { canIntermediateTextStrikeoff, getIntermediateTextFontStyles } from "@core-ui/helpers/BillDetailsHelper";
import { RenderingDetailsMeta } from "@swiggy-private/cart-types";

import styles from "../../../BillDetailItem.scss";

const IntermediateText = ({
    intermediateText,
    meta,
    intermediateTextStyle,
    isNested,
}: {
    intermediateText?: string;
    meta: RenderingDetailsMeta;
    intermediateTextStyle?: string;
    isNested?: boolean;
}): ReactElement | null => {
    if (isEmpty(intermediateText)) {
        return null;
    }

    const className = classNames(
        styles.displayValueIntermediate,
        {
            [styles.displayValueStrikeoff]: canIntermediateTextStrikeoff({
                meta,
            }),
            [styles.displayValueStrikeoffNested]: isNested,
        },
        intermediateTextStyle,
    );

    const fontStyles = getIntermediateTextFontStyles({ meta });

    return (
        <AriaHidden as="div" className={className} style={fontStyles}>
            {intermediateText}
        </AriaHidden>
    );
};

export default memo(IntermediateText);
